<script>
import Vue from 'vue'
import { AgGridVue } from 'ag-grid-vue'

import RuleGroupResource from '../../resources/ruleGroup'
import toastMixin from '../../mixins/toast'

export default Vue.extend({
    name: 'RuleGroupGrid',
    components: {
        AgGridVue,
    },
    props: {},
    mixins: [toastMixin],
    data() {
        return {
            gridApi: undefined,
            columnApi: undefined,
            ruleGroupColumnDefs: [
                {
                    field: 'id',
                    headerName: 'ID#',
                    sortable: true,
                    width: 60,
                    valueSetter: () => null,
                    valueGetter: (params) => {
                        return params.data.id
                    },
                },
                {
                    field: 'name',
                    headerName: 'name',
                    sortable: true,
                    editable: true,
                    valueSetter: (params) => {
                        params.data.set('name', params.newValue)
                    },
                    valueGetter: (params) => {
                        return params.data.attributes.name
                    },
                },
                {
                    field: 'description',
                    headerName: 'description',
                    sortable: true,
                    editable: true,
                    valueSetter: (params) => {
                        params.data.set('description', params.newValue)
                    },
                    valueGetter: (params) => {
                        return params.data.attributes.description
                    },
                },
                {
                    field: 'value',
                    headerName: 'value',
                    sortable: true,
                    editable: true,
                    valueSetter: (params) => {
                        params.data.set('value', params.newValue)
                    },
                    valueGetter: (params) => {
                        return params.data.attributes.value
                    },
                },
                {
                    field: 'status',
                    headerName: 'status',
                    sortable: true,
                    editable: true,
                    valueSetter: (params) => {
                        params.data.set('status', params.newValue)
                    },
                    valueGetter: (params) => {
                        return params.data.attributes.status
                    },
                },
            ],
            ruleGroupRowData: [],
            ruleGroupGridOptions: {
                defaultColDef: {
                    resizable: true,
                    singleClickEdit: true,
                    undoRedoCellEditing: true,
                    enterMovesDown: true,
                    enterMovesDownAfterEdit: true,
                },
                onGridReady: (params) => {
                    if (params) {
                        this.gridApi = params.api
                        this.columnApi = params.columnApi
                    }
                },

                onFirstDataRendered: (params) => {
                    params.api.sizeColumnsToFit()
                },
            },
        }
    },
    computed: {
        resources() {
            return {
                RuleGroupResource,
            }
        },
    },
    methods: {
        selectRuleGroup(params) {
            if (params && params.data && params.data.attributes) this.$emit('select', params.data)
        },

        async saveGrid() {
            if (!changes) this.createToast('b-toaster-top-center', 'warning', true, 'Warning', 'No Data to Save')
            else this.createToast('b-toaster-top-center', 'success', true, 'Success', 'Finished Save')

            let changes = false
            if (!this.ruleGroupRowData || !this.ruleGroupRowData.length) {
                this.createToast('b-toaster-top-center', 'warning', true, 'Warning', 'No Data to Save')
                return false
            }

            this.ruleGroupRowData.forEach(async (row) => {
                if (row.changes && Object.keys(row.changes).length) {
                    changes = true
                    row.validate()
                    try {
                        await row.save()
                        row.changes = {}
                    } catch (error) {
                        // console.log(error)
                        this.createToast('b-toaster-top-center', 'danger', true, 'Save Error', error, true)
                        throw error
                    }
                }
            })

            if (!changes) this.createToast('b-toaster-top-center', 'warning', true, 'Warning', 'No Data to Save')
            else this.createToast('b-toaster-top-center', 'success', true, 'Success', 'Finished Save')
        },

        exportGrid() {
            this.gridApi.exportDataAsExcel()
        },
    },
    async mounted() {
        this.ruleGroupRowData = await RuleGroupResource.all()
    },
})
</script>

<template>
    <div>
        <h1>Rule Groups Grid</h1>
        <div class="right">
            <b-button variant="outline-success" @click="exportGrid">Export</b-button>
            <b-button variant="primary" @click="saveGrid">Save</b-button>
        </div>
        <div class="clear"></div>
        <ag-grid-vue class="ag-theme-balham default-grid" :grid-options="ruleGroupGridOptions" :column-defs="ruleGroupColumnDefs" :row-data="ruleGroupRowData" @row-clicked="selectRuleGroup" />
        <div class="clear"></div>
        <div class="right">
            <b-button variant="outline-success" @click="exportGrid">Export</b-button>
            <b-button variant="primary" @click="saveGrid">Save</b-button>
        </div>
        <div class="clear"></div>
        <hr />
    </div>
</template>

<style>
@import '../../../node_modules/ag-grid-community/dist/styles/ag-grid.css';
@import '../../../node_modules/ag-grid-community/dist/styles/ag-theme-balham.css';

.default-grid {
    width: 100%;
    height: 200px;
}
</style>
